import React, {Component} from 'react';
import styled from 'styled-components/macro'
import breakpoint from 'styled-components-breakpoint';
import {Author, MinRead} from "./PreviewElements"
import PropTypes from "prop-types";

const BoxRow = styled.div.attrs({
    className: "row",
})`
    padding-top: 1rem;
    padding-bottom: 1rem;
    &:hover {
        cursor: pointer;
    }
`;

const BoxCol = styled.div.attrs({
    className: "col-lg-10 col-xs-12",
})`
    background-color: #fcfcfc;

    ${breakpoint('md')`
        filter: drop-shadow(5px 5px 10px rgb(51, 29, 78, .16));
        border-radius: 15px;
        margin-top: 2rem;
    `}
`;

const ImageColumn = styled.div.attrs({
    className: "col-lg-2 col-sm-offset-3 col-lg-offset-1 col-sm-2"
})`
    align-self: center;
    ${breakpoint('xs', 'lg')`
        display:none
    `} 
    > img {
        width: 100%;
    }        
`;
const Spacing = styled.div.attrs({
    className: "col-lg-2 col-sm-offset-3 col-lg-offset-1 col-sm-2"
})`
   margin-bottom: 13em;
`;

const PreviewTextColumn = styled.div.attrs({
    className: "col-lg-8 col-lg-offset-1 col-sm-11"
})`
    margin-left:3%;
`;

const HeaderRow = styled.div.attrs({
    className: "row"
})`
`;

const HeaderColumn = styled.div.attrs({
    className: "col-xs-10"
})`
    padding-bottom: 0.4rem;
    padding-top: 0.5rem;
    
`;

const SubHeaderRow = styled.div.attrs({
    className: "row between-lg between-xs"
})`
    padding-top: 0rem;
    font-size: 1rem;
`;

const DateColumn = styled.div.attrs({
    className: "col-lg-2 col-xs-4"
})`
    font-family: ${props => props.theme.highlightFontFamily};
    color: ${props => props.theme.highlightColor};
`;

const AuthorColumn = styled.div.attrs({
    className: "col-lg-2 col-xs-3"
})`
    font-family: ${props => props.theme.highlightFontFamily};
    color: ${props => props.theme.greyHighlight};
`;

const ReadTimeColumn = styled.div.attrs({
    className: "col-lg-8 col-xs-4"
})`
`;


const SummaryRow = styled.div.attrs({
    className: "row"
})`
    font-family: ${props => props.theme.largeTextFamily};
    text-align: justify;
    padding-top: 0.5rem;
`;

const SummaryColumn = styled.div.attrs({
    className: "col-lg-12 col-md-12 col-xs-12"
})``;

const PreviewTextHeader = styled.h1`
    font-family: 'CrimsonMedium';
    font-size: 2rem;
    font-weight: inherit;
`;

class Preview extends Component {
    render() {
        let imageColumn;
        if (this.props.mainImage) {
            imageColumn = (
                <ImageColumn>
                    <img src={this.props.mainImage} alt=""/>
                </ImageColumn>
            )
        }else {
            imageColumn = (
                <Spacing/>
            )
        }

        const author = (<Author link={this.props.authorSocialLinkType} name={this.props.authorName}/>)

        const dateFormatted = this.props.date.substr(0,10);
        return (
            <BoxCol>
                <BoxRow>
                    <PreviewTextColumn>
                        <HeaderRow>
                            <HeaderColumn>
                                <PreviewTextHeader>
                                    {this.props.header}
                                </PreviewTextHeader>
                            </HeaderColumn>
                        </HeaderRow>
                        <SubHeaderRow>
                            <DateColumn>
                                <div>{dateFormatted}</div>
                            </DateColumn>
                            <AuthorColumn>
                                {author}
                            </AuthorColumn>
                            <ReadTimeColumn>
                                <MinRead time={this.props.readTime}/>
                            </ReadTimeColumn>
                        </SubHeaderRow>
                        <SummaryRow>
                            <SummaryColumn>
                                <div>{this.props.summary}</div>
                            </SummaryColumn>
                        </SummaryRow>
                        <SummaryRow>
                            <SummaryColumn>
                                <div>{this.props.teaser}</div>
                            </SummaryColumn>
                        </SummaryRow>
                    </PreviewTextColumn>
                    {imageColumn}
                </BoxRow>
            </BoxCol>
        );
    }
}

Preview.defaultProps = {
    authorName: "nisabek",
    authorSocialLinkType: "twitter"
};

Preview.propTypes = {
    authorName: PropTypes.string,
    authorSocialLinkType: PropTypes.string,
    summary: PropTypes.string.isRequired,
    teaser: PropTypes.string.isRequired,
    readTime: PropTypes.number.isRequired
};

export default Preview;
